// @flow
import React from "react"
import { compose, withHandlers, type HOC } from "recompose"
import withRouter from "hoc/withRouter"
import withConnect from "hoc/withConnect"
import urls from "data/router/urls"
import { triggerRecentSearch } from "data/search/actions"
import { selectRecentSearches } from "data/search/selectors"
import type { AutocompleteItem } from "data/search/graphql/queries/autocomplete"
import { ItemGroupsWrap, GroupWrap, GroupLabel, GroupItem } from "../styled"

const RecentSearches = ({ recentSearches, handleClick }) => {
  if (recentSearches.length === 0) return null

  return (
    <ItemGroupsWrap>
      <GroupWrap>
        <GroupLabel>Recent Searches</GroupLabel>
        {recentSearches.map((s, i) => (
          <GroupItem key={i} onClick={() => handleClick(s)}>
            {s.name}
          </GroupItem>
        ))}
      </GroupWrap>
    </ItemGroupsWrap>
  )
}

const mapStateToProps = state => ({
  recentSearches: selectRecentSearches(state),
})

const mapDispatchToProps = {
  triggerRecentSearch,
}

type Outter = {|
  close: Function,
|}

const enhancer: HOC<*, Outter> = compose(
  withRouter,
  withConnect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    handleClick: props => (item: AutocompleteItem) => {
      props.triggerRecentSearch(item)

      if (item.type === "affiliate") {
        props.history.push(urls.affiliate(item.id))
      }

      props.close()
    },
  }),
)

export default enhancer(RecentSearches)



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/LoggedInNav/SearchAutocomplete/AutocompleteContent/RecentSearches/index.js